import { Heading, HeadingTag } from "components/common/Heading";
import { IndicativeCalculationBanner } from "components/common/IndicativeCalculationBanner";
import { LoanDetails } from "domain/yourBBLS";
import { CreateEnhancer } from "util/enhancer";
import { LoanSummary } from "./LoanSummary";
import { YourAvailableOptions } from "./YourAvailableOptions";

type YourBounceBackLoanProps = {
  loanDetails: LoanDetails;
};
const YourBounceBackLoan = ({ loanDetails }: YourBounceBackLoanProps) => {
  return (
    <div className="yourBounceBackLoan-screen">
      <Heading
        tag={HeadingTag.h1}
        size={1}
        className="zb-heading1 screen-header"
        title="Your Bounce Back Loan"
      />
      <LoanSummary loanDetails={loanDetails} />
      <div className="loan-note section-margin">
        <IndicativeCalculationBanner />
      </div>
      <YourAvailableOptions loanDetails={loanDetails} />
    </div>
  );
};

const YourBounceBackLoanEnhanced = CreateEnhancer<
  YourBounceBackLoanProps,
  "loanDetails"
>((p) => !p.loanDetails)(YourBounceBackLoan);

export { YourBounceBackLoanEnhanced as YourBounceBackLoan };
